import {
  creerMagasinPresentation,
  type MagasinPresentation,
  type PresentationPreparee,
} from './magasin.js';

const PREFIXE = 'artosera-presentation:';
const adresse = (chemin: string) => new URL(`/__presentation/${chemin}`, location.origin).href;

export function magasinPresentationCache(stockage: CacheStorage = caches): MagasinPresentation {
  return creerMagasinPresentation({
    async ecrire(id, preparation) {
      // Retirer la sélection précédente évite de garder des images sorties de sa liste.
      await stockage.delete(`${PREFIXE}${id}`);
      const cache = await stockage.open(`${PREFIXE}${id}`);
      const { images, ...document } = preparation;
      let index = 0;
      for (const image of images.values())
        await cache.put(adresse(`image/${index++}`), new Response(image));
      await cache.put(
        adresse('selection'),
        new Response(JSON.stringify({ ...document, images: [...images.keys()] }), {
          headers: { 'Content-Type': 'application/json' },
        }),
      );
    },
    async lire(id) {
      if (!(await stockage.keys()).includes(`${PREFIXE}${id}`)) return null;
      const cache = await stockage.open(`${PREFIXE}${id}`);
      const reponse = await cache.match(adresse('selection'));
      if (!reponse) return null;
      const document = (await reponse.json()) as Omit<PresentationPreparee, 'images'> & {
        images: string[];
      };
      const images = new Map<string, Blob>();
      for (const [index, url] of document.images.entries()) {
        const image = await cache.match(adresse(`image/${index}`));
        if (!image) {
          await stockage.delete(`${PREFIXE}${id}`);
          return null;
        }
        images.set(url, await image.blob());
      }
      return { ...document, images };
    },
    identifiants: async () =>
      (await stockage.keys())
        .filter((nom) => nom.startsWith(PREFIXE))
        .map((nom) => nom.slice(PREFIXE.length)),
    effacer: async (id) => {
      await stockage.delete(`${PREFIXE}${id}`);
    },
  });
}
